<template>
  <dp-loading v-if="false" />
  <BaseContainer v-else>
    <template #header>
      <b-img center class="city-logo-img" :src="getImage(city.letterLogo.original)" :alt="city.letterLogo.imageAltText || city.organization" fluid />
    </template>

    <section>
      <h1 class="text-center font-weight-bold">{{ $t('views.interrupt.title') }}</h1>
      <p class="my-4">
        {{ $tc('views.interrupt.body', renewalPetsInOrder.length, { cityName: city.organization, petName: petNames }) }}
      </p>
    </section>

    <b-link class="btn btn-outline-primary my-2 w-100" :href="licensingAppLink">{{
      $tc('views.interrupt.buttonPurchaseLicense', renewalPetsInOrder.length)
    }}</b-link>
    <b-link class="btn btn-outline-primary my-2 w-100" :to="{ name: nextRoute }">{{
      $tc('views.interrupt.buttonContinue', renewalPetsInOrder.length)
    }}</b-link>
  </BaseContainer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getImage } from '@/utils';
import baseLocaleUrl from '@/mixins/baseLocaleUrl';
import BaseContainer from '@/components/BaseContainer';
import { DpLoading } from '@docupet/component-library';

export default {
  name: 'Interrupt',
  components: {
    BaseContainer,
    DpLoading,
  },
  mixins: [baseLocaleUrl],
  computed: {
    ...mapState({
      city: (state) => (state.order.order ? state.order.order.city : null),
    }),
    ...mapGetters({
      renewalPetsInOrder: 'order/renewalPetsInOrder',
    }),
    petNames() {
      let names = this.renewalPetsInOrder.map(({ name }) => name);
      if (names.length <= 1) return names.join();
      else return names.slice(0, -1).join(', ') + ' and ' + names.slice(-1);
    },
    licensingAppLink() {
      return this.$store.getters.generateFullUrl('/order/verify_info');
    },
    nextRoute() {
      if (this.$router?.currentRoute?.params?.nextRoute) {
        return this.$router?.currentRoute?.params?.nextRoute;
      }

      return this.city?.skipDonation ? 'Payment' : 'Donation';
    },
  },
  methods: {
    getImage,
  },
};
</script>

<style lang="scss" scoped>
.city-logo-img {
  max-height: 180px;
  width: auto;
}
</style>
